export const findInputs = (inputs, step_index) => {
  let step = {};
  inputs["steps"].forEach((el) => {
    if (el["index"] === step_index) {
      step = el;
    }
  });
  return step;
};
